import { YouTubeEmbed } from '@next/third-parties/google';
import type { CSSProperties } from 'react';
type Props = {
  href?: string;
  youtubeid?: string;
  title?: string;
  ratio?: string;
};

export const YouTube = (props: Props) => {
  let { youtubeid } = props;
  const { href, title } = props;

  if (!youtubeid) {
    if (href?.includes('embed')) {
      youtubeid = href.match(/(?:\/embed\/)([^/?]+)/)![1];
    } else if (href?.includes('v=')) {
      youtubeid = new URLSearchParams(new URL(href as string)?.search).get(
        'v'
      )!;
    } else {
      return null;
    }
  }

  const hoverStyleFix = { '--hover-color': 'transparent' } as CSSProperties;
  return (
    <div
      data-yt-video-id={youtubeid}
      data-yt-video-src={href}
      style={hoverStyleFix}
      className="youtube-embed-fix-hover ui-h-full [&>div]:!ui-h-full [&_lite-youtube]:after:ui-pb-0"
    >
      <YouTubeEmbed
        videoid={youtubeid}
        playlabel={title}
        style={`max-width:100%; max-height:100%; aspect-ratio:${props.ratio || '16 / 9'};`}
      />
    </div>
  );
};

export default YouTube;
